import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import * as syncProductCategoryActions from "../../slices/syncdata/syncProductCategory.slice";
import { http } from "utils/http";
import { endPoint } from "constants/server/api";
export var syncProductCategory = function(payload) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, modalObj = _ref.modalObj, setModalObj = _ref.setModalObj;
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            var accessToken, config, result, error, _error_response_data, statusCode;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch(syncProductCategoryActions.fetchData());
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        accessToken = localStorage.getItem("accessToken");
                        config = {
                            method: "post",
                            headers: {
                                Authorization: "Bearer ".concat(accessToken)
                            },
                            url: endPoint.SYNC_PRODUCT_CATEGORY,
                            data: payload
                        };
                        return [
                            4,
                            http(config)
                        ];
                    case 2:
                        result = _state.sent();
                        dispatch(syncProductCategoryActions.fetchDataSuccess(result.data));
                        return [
                            2,
                            result.data
                        ];
                    case 3:
                        error = _state.sent();
                        dispatch(syncProductCategoryActions.fetchDataFailure());
                        if (typeof setModalObj === "function") {
                            if (http.isAxiosError(error) && error.response) {
                                ;
                                statusCode = error.response.status;
                                setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                                    visible: true,
                                    subTitle: "รหัส ".concat(statusCode),
                                    navigateDirection: undefined,
                                    title: ((_error_response_data = error.response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) || "ไม่สามารถซิงค์ข้อมูลได้"
                                }));
                            } else {
                                setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                                    visible: true,
                                    subTitle: "รหัส 500",
                                    navigateDirection: undefined,
                                    title: "เกิดข้อผิดพลาด\nหรือเครือข่ายขัดข้อง"
                                }));
                            }
                        }
                        return [
                            2,
                            false
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var clearSyncProductCategory = function() {
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            return _ts_generator(this, function(_state) {
                dispatch(syncProductCategoryActions.resetState());
                return [
                    2
                ];
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
